import React from 'react';

import type { Section } from '../../../models/index';
import type { SwitchObject } from '../../../models/Types';
import { ELECTRICITY, TRASH_REMOVAL, WATER_SEWER } from '../../../constants';
import SwitchesWithTitle from '../../Widgets/SwitchesWithTitle';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function Utilities({ section, setSectionValues }: Props): JSX.Element {
  const utilities: Array<SwitchObject> = [
    {
      text: 'Electricity',
      onClick: onElectricityToggle,
      toggled: section.getFieldValue(ELECTRICITY.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(ELECTRICITY.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Water/sewer',
      onClick: onWaterSewerToggle,
      toggled: section.getFieldValue(WATER_SEWER.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(WATER_SEWER.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Trash removal',
      onClick: onTrashRemovalToggle,
      toggled: section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED),
    },
  ];

  function onElectricityToggle(): void {
    toggleSwitch(ELECTRICITY.FIELD_NAME.IS_ENABLED);
  }

  function onWaterSewerToggle(): void {
    toggleSwitch(WATER_SEWER.FIELD_NAME.IS_ENABLED);
  }

  function onTrashRemovalToggle(): void {
    toggleSwitch(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED);
  }

  function toggleSwitch(key: string): void {
    setSectionValues({
      [key]: !section.getFieldValue(key),
    });
  }

  return (
    <SwitchesWithTitle
      switches={utilities}
      title="Utilities and services"
      legend="Which utilities will be paid by the tenant in addition to base rent?"
    />
  );
}
